import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-results-brands",
  class PredictiveSearchResultsBrands extends WYATTElement {
    constructor() {
      super();

      this.resultsContainer = this.querySelector("[data-results]");
      this.itemTemplate = this.querySelector("[data-template='item']");
    }

    sort = (a, b) => (b.count ?? 0) - (a.count ?? 0);

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.predictiveSearchBrandsFetched,
        this.update.bind(this),
      );
    }

    update(event) {
      const brands = event?.detail?.find((facet) => facet.field === "vendor");

      if (!brands?.values?.length) {
        this.resultsContainer.innerHTML = `<p>${WYATT.t.predictiveSearchResults.noResults}</p>`;
        return;
      }

      this.resultsContainer.innerHTML = "";

      this.renderBrands(brands);
    }

    renderBrands(brands) {
      const sortedBrands = [...brands.values].sort(this.sort);

      sortedBrands.slice(0, 6).forEach(this.renderBrand.bind(this));
    }

    renderBrand(brand) {
      const item = this.itemTemplate.content.cloneNode(true).firstElementChild;
      item.dataset.result = JSON.stringify(brand);
      this.resultsContainer.appendChild(item);
    }
  },
);
